"use client";

import { useRef } from "react";

export function Scene3D({ children }: { children: React.ReactNode }) {
  const rig = useRef<HTMLDivElement>(null);

  function onMove(event: React.MouseEvent<HTMLDivElement>) {
    const box = event.currentTarget.getBoundingClientRect();
    const x = (event.clientX - box.left) / box.width - 0.5;
    const y = (event.clientY - box.top) / box.height - 0.5;
    if (rig.current) {
      rig.current.style.transform = `rotateX(${12 - y * 10}deg) rotateY(${-18 + x * 16}deg)`;
    }
  }

  function onLeave() {
    if (rig.current) {
      rig.current.style.transform = "rotateX(12deg) rotateY(-18deg)";
    }
  }

  return (
    <div className="scene h-[460px] w-full" onMouseMove={onMove} onMouseLeave={onLeave}>
      <div ref={rig} className="scene-rig relative h-full w-full">
        {children}
      </div>
    </div>
  );
}
